





































import { Vue, Component, Prop } from "vue-property-decorator";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import ActivityLink from "@/components/activity";
import NoData from "@/basics/boxes/NoData.vue";
import CButton from "@/basics/buttons/CButton.vue";
import { RequestGroupUserLink } from "@/components/activity/helper";
import {
  Activity,
  ACTIVITY_FEED,
  ActivityArgs,
  ActivityFeed
} from "@/graphql/query/activity/feed";
import formatDate from "@/lib/formatDate";

type A = Activity & { timestamp: string };

@Component({
  components: {
    SimpleTable,
    ActivityLink,
    NoData,
    RequestGroupUserLink,
    CButton
  },
  apollo: {
    activityFeed: {
      query: ACTIVITY_FEED,
      variables(): ActivityArgs {
        return {
          page: this.page,
          count: this.count,
          start: this.start ? this.start.getTime() : null,
          end: this.end ? this.end.getTime() : null,
          requestGroupId: this.requestGroupId,
          requestUserId: this.requestUserId,
          groupId: this.groupId,
          userId: this.userId,
          appUserId: this.appUserId,
          buildingId: this.buildingId,
          roomId: this.roomId,
          telephoneKeyId: this.telephoneKeyId
        };
      }
    }
  }
})
export default class ActivityViewer extends Vue {
  @Prop({ type: Number, required: false, default: 20 }) count!: number;
  @Prop({ type: Number, required: false }) start?: Date;
  @Prop({ type: Number, required: false }) end?: Date;
  @Prop({ type: String, required: false }) requestGroupId?: string;
  @Prop({ type: String, required: false }) requestUserId?: string;
  @Prop({ type: String, required: false }) groupId?: string;
  @Prop({ type: String, required: false }) userId?: string;
  @Prop({ type: String, required: false }) appUserId?: string;
  @Prop({ type: String, required: false }) buildingId?: string;
  @Prop({ type: String, required: false }) roomId?: string;
  @Prop({ type: String, required: false }) telephoneKeyId?: string;

  activityFeed: ActivityFeed | null = null;

  get page(): number {
    return Number(this.$route.query.p || 1);
  }

  async show(page: number) {
    this.$router.push({ query: { p: page.toString() } });
  }

  formatDate(time: number): string {
    return formatDate(new Date(time));
  }
}
